import React, { Component } from 'react'
import { TableRow, TableCell } from '@material-ui/core'
import { EditableCheckbox } from '../../common/EditableComponents'

export default class AddProductSync extends Component {
  render() {
    const { productsToSync, product, onCheckProduct } = this.props
    return (
      <TableRow>
        <TableCell>
          <EditableCheckbox
            productsToSync
            // checked={this.props.allselected ? this.props.allselected : this.props.mapProducts && this.props.mapProducts[this.props.product.id] || ''}
            checked={productsToSync.includes(product.id) || false}
            valueToRender={''}
            editMode={true}
            onChange={() => onCheckProduct(product.id)}
            className="table-cus-checkbox"
          />
        </TableCell>
        <TableCell> {product.name} </TableCell>
      </TableRow>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedMapMenuList/AddProductSync.js